//axios api
import api from "@/lib/Api";

export const loginByStaffCode = async (staffCode, password) => {
  try {
    if (staffCode !== "" && password !== "") {
      const queryRoute = "/user/login";

      const reqBody = {
        staffCode: staffCode,
        password: password,
      };
      const fetchRes = api.axios.post(queryRoute, reqBody);
      return (await fetchRes).data;
    }
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getRefreshToken = async (refreshToken) => {
  try {
    const queryRoute = "/user/getRefreshToken";

    const headers = {
      headers: {
        refreshToken: refreshToken,
      },
    };
    const fetchRes = api.axios.post(queryRoute, undefined, headers);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
